import { gql } from '@apollo/client';

export const CREATE_BIDS = gql`
  mutation CreateBids($bids: [BidInput]!) {
    createBids(bids: $bids) {
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;

export const EDIT_BID = gql`
  mutation EditBid($bid: EditBidInput!) {
    editBid(bid: $bid) {
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
      bid {
        id
        amount
        history {
          id
          profileType
          created
          amount
        }
      }
    }
  }
`;

export const CANCEL_BID = gql`
  mutation CancelBid($bid: CancelBidInput!) {
    cancelBid(bid: $bid) {
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
      bid {
        id
        finalStatus
      }
    }
  }
`;

export const CANCEL_BID_REQUEST = gql`
  mutation ($cancelBidRequest: CancelBidRequestInput!) {
    cancelBidRequest(cancelBidRequest: $cancelBidRequest) {
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
      cancelationRequest {
        status
      }
    }
  }
`;

export const REVIEW_BID = gql`
  mutation ReviewBid($bidId: ID! $bidReview: BidReviewInput, $reviewFromModal: Boolean!) {
    bidReview(bidId: $bidId, bidReview: $bidReview, reviewFromModal: $reviewFromModal) {
      success
      error {
        __typename
        ... on ValidationErrors {
            validationErrors {
                field
                messages
            }
        }
      }
    }
  }
`;
